import { useQuery } from '@tanstack/react-query';
import { documentLibraryControllerGetDealClassifiersByGroupsOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';

export const useClassifierGroups = (dealId: string) => {
	const { data: treeItemsData, isLoading: isTreeItemsMenuLoading } = useQuery({
		// Generated query options: structured key + a queryFn that unwraps the
		// response and throws on error.
		...documentLibraryControllerGetDealClassifiersByGroupsOptions({ path: { dealId } }),
		enabled: !!dealId,
	});

	return {
		treeItemsData,
		isTreeItemsMenuLoading,
	};
};
